import { FormDefaultValues } from "./types";

export const defaultValues: FormDefaultValues = {
    compliance: null
}